// internationalization
import type { TFunction } from 'i18next';

// libraries
import { z } from 'zod';

export function createEditMeterDisplayNameFormSchema(t: TFunction) {
  return z.object({
    displayName: z.string().min(1, t('input.required', { ns: 'validation' })),
  });
}

export type EditMeterDisplayNameFormValues = z.infer<
  ReturnType<typeof createEditMeterDisplayNameFormSchema>
>;
